import * as Sentry from '@sentry/browser';

// Self-executing Sentry initialisation
(function initSentryBrowser() {
	// eslint-disable-next-line no-undef
	const config = typeof sentry_config === 'object' ? sentry_config : {};
	const {
		dsn,
    release = '',
		environment = 'prod',
		tracesSampleRate = 1.0,
	} = config;


	if (!dsn) return;

	/**
	 * Reports a custom error to Sentry.
	 * @param {unknown} error - The error to report.
	 * @param {Object} [context] - Optional context (metadata).
	 */
	window.captureSentryError = (error, context) => {
		if (error instanceof Error) {
			Sentry.withScope((scope) => {
				if (context) scope.setExtras(context);
				Sentry.captureException(error);
			});
		} else {
			const message =
				typeof error === 'string' ? error : 'Unknown non-error thrown';
			Sentry.captureMessage(message, 'error');
		}
	};

	/**
	 * List of error messages to exclude from Sentry reporting.
	 * @type {string[]}
	 */
	const excludedErrors = ['Failed to fetch', 'Load failed'];

	Sentry.init({
		dsn,
    release,
    environment,
		denyUrls: [],
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.thirdPartyErrorFilterIntegration({
				filterKeys: ['guide-dogs-js'],
				// behaviour: 'apply-tag-if-exclusively-contains-third-party-frames',
			}),
		],
		tracesSampleRate,
		beforeSend(event, hint) {
			const error = hint?.originalException;
			if (error instanceof Error) {
				const message = error.message || '';
				if (excludedErrors.some((ex) => message.includes(ex))) {
					return null; // prevent sending
				}
			}
			return event;
		},
	});
})();
